<!--
* @Description: 等级介绍-考试形式-例题流程
* @Author: shuowang13
* @Date: 2024-08-14
* @LastEditTime: 2024-08-14
* @LastEditors: shuowang13
-->
<template>
  <div>
    <Answer-progress-Upgrade
      v-if="Object.keys(resourceObj).length"
      :selectObj="resourceObj"
      @currentSelect="currentSelect($event)"
      @play="playAudio"
      @pause="pauseAudio"
      @stop="playStop"
      @submitAnswer="submitAnswer"
      :title="filterPaperName(titleTrans)"
      ref="progress"
      :answerObject="answerObject"
      :answerNotesArray="answerNotesArray"
      :showButtonPlay="showButtonPlay"
      :showButtonPause="showButtonPause"
      :time="time"
      :isShowCountDown="isShowCountDown"
      :isExamMode="isExamMode"
    >
      <div slot="content">
        <component
          :is="currentHSKComponent"
          :jsonData="currItem"
          :currItem="currItem"
          :isExamMode="isExamMode"
          @saveRes="saveRes($event)"
          :key="currItem.count"
          ref="componentRef"
          :isShowAnAnalysis="!isExamMode"
          :baseUrl="$route.query.root_path"
          isSpecial
          leaveCloseVideo
        ></component>
      </div>
    </Answer-progress-Upgrade>
  </div>
</template>

<script>
import AnswerProgressUpgrade from '@/components/hsk/answerProgressUpgrade.vue'
import Judgment from '@/components/hsk/judgment'
import SelectPicByVoice from '@/components/hsk/selectPicByVoice'
import SelectTextByVoice from '@/components/hsk/selectTextByVoice'
import SetChoosePicByText from '@/components/hsk/setChoosePicByText'
import SetChoosePicByVoice from '@/components/hsk/setChoosePicByVoice'
import SetChooseTextByText from '@/components/hsk/setChooseTextByText'
import JoinSentence from '@/components/hsk/joinSentence'
import FillInBlank from '@/components/hsk/fillInBlank'
import ReadingOrder from '@/components/hsk/readingOrder'
import SetChooseTextByVoice from '@/components/hsk/setChooseTextByVoice'
import SetReadChooseTextBySentence from '@/components/hsk/setReadChooseTextBySentence'
import SetReadChooseTextFillBlank from '@/components/hsk/setReadChooseTextFillBlank'
import SelectTextReadingComprehension from '@/components/hsk/selectTextReadingComprehension'
import Abbreviation from '@/components/hsk/abbreviation'
import MakeSentence from '@/components/hsk/makeSentence'
import { HSK_COMMPONENTS } from '@/config'
import { backLayerHandler } from '@/utils/utils'
import Vue from 'vue'

export default {
  components: {
    AnswerProgressUpgrade,
    Judgment,
    SelectPicByVoice,
    SelectTextByVoice,
    SetChoosePicByText,
    SetChoosePicByVoice,
    SetChooseTextByText,
    JoinSentence,
    FillInBlank,
    ReadingOrder,
    SetChooseTextByVoice,
    SetReadChooseTextBySentence,
    SetReadChooseTextFillBlank,
    SelectTextReadingComprehension,
    MakeSentence,
    Abbreviation,
  },
  data() {
    return {
      // resourceList: [],
      resourceObj: {},
      currItem: {},
      answerObject: {},
      // dialogVisible: false,
      time: 30 * 60 * 60 * 1000, // 倒计时时间
      //是否显示播放按钮
      showButtonPlay: true,
      // 是否第一个未作答的题
      isFirstQuestion: false,
      // 作答记录数组
      answerNotesArray: [],
      // 是否显示倒计时以及提交按钮
      isShowCountDown: true,
      showButtonPause: false,
      // 是否提交了答案
      isSubmitAnswer: false,
      titleTrans: {},
    }
  },
  computed: {
    //当前题型组件
    currentHSKComponent() {
      let component = HSK_COMMPONENTS[this.currItem.topic_type]
      console.log(component)
      return component
    },
    //是否是答题模式
    isExamMode() {
      return !(this.$route.query.paperStatus == 1)
    },
  },

  mounted() {
    this.resourceObj = JSON.parse(localStorage.getItem('practiceJson')).jsonData
    this.answerNotesArray = JSON.parse(localStorage.getItem('practiceJson')).answerNotesArray
    console.log(' this.resourceObj======', this.resourceObj, this.answerNotesArray)
  },
  watch: {
    // 监听选择了答案直接下一题
    currItem: {
      handler(newVal) {
        let isListenGroup =
          newVal.topic_type == 'ea' &&
          newVal.questions.find((item) => item.listen && item.listen.audio_file)
        if (
          newVal.segment_code == 'listen' &&
          newVal.topic_type != 'xt' &&
          newVal.topic_type != 'lt' &&
          !isListenGroup
        ) {
          this.$player.stop()
          this.showButtonPlay = true
          this.showButtonPause = false
        } else {
          this.showButtonPlay = false
          this.showButtonPause = false
        }
      },
      deep: true,
    },
  },
  methods: {
    filterPaperName(nameTrans) {
      let language = localStorage.getItem('language')
      if (language === 'zh') {
        language = 'cn'
      }

      return nameTrans[language]
    },

    // 1、选择答题卡后执行的 2、首次执行
    currentSelect(obj) {
      console.log('currItem', obj)
      this.currItem = obj
      // 兼容新资源数据把listen 存到 content中去
      if (this.currItem.listen) {
        this.currItem.content = this.currItem.listen.audio_file
      }
      let isListenGroup =
        obj.topic_type == 'ea' &&
        obj.questions.find((item) => item.listen && item.listen.audio_file)
      if (
        obj.segment_code == 'listen' &&
        obj.topic_type != 'xt' &&
        obj.topic_type != 'lt' &&
        !isListenGroup
      ) {
        if (!obj.answer && this.$route.query.paperStatus != 1) {
          setTimeout(() => {
            this.playAudio()
          }, 400)
        }
      } else if (
        (obj.topic_type == 'xt' || obj.topic_type == 'lt' || isListenGroup) &&
        this.$route.query.paperStatus != 1
      ) {
        this.showButtonPlay = false
        this.showButtonPause = false
        this.$nextTick(() => {
          console.log(
            this.$refs.componentRef,
            this.currentHSKComponent,
            this.resourceObj.topic_type
          )
          if (!obj.answer[obj?.count - 1]) {
            // 没值才自动播放
            this.$refs.componentRef.autoPlay(obj)
          }
        })
      } else {
        this.$player && this.$player.stop()
        this.showButtonPlay = false
        this.showButtonPause = false
      }
    },
    //点击播放音频
    playAudio() {
      this.showButtonPlay = false
      this.showButtonPause = true
      let audioPath = this.$route.query.root_path + this.currItem.content
      this.$player.play(audioPath)
      this.$player.onended = () => {
        this.showButtonPlay = true
        this.showButtonPause = false
      }
    },
    //点击暂停音频
    pauseAudio() {
      this.$player.pause()
      this.showButtonPlay = true
      this.showButtonPause = false
    },
    //停止播放音频
    playStop() {
      if (
        this.currItem.segment_code == 'listen' &&
        this.currItem.topic_type != 'xt' &&
        this.currItem.topic_type != 'lt'
      ) {
        this.$player.stop()
        this.showButtonPlay = true
        this.showButtonPause = false
      } else if (this.currItem.topic_type == 'xt' || this.currItem.topic_type == 'lt') {
        this.$player.stop()
        this.showButtonPlay = false
        this.showButtonPause = false
      }
    },
    // 保存做完的题目
    saveRes(obj) {
      console.log('finished', obj)
      this.answerObject = obj
    },
    // 提交答案改变状态
    submitAnswer() {
      this.isSubmitAnswer = true
    },
  },
  beforeRouteLeave(to, from, next) {
    // ...
    console.log(this.$route.query)
    if (this.isSubmitAnswer || this.$route.query.paperStatus == 1) {
      next()
      new Vue().$player.stop()
    } else {
      backLayerHandler(
        () => {
          // 确定后执行的操作
          //await this.$refs.progress.saveApiRequest()

          next()
          new Vue().$player.stop()
        },
        {
          type: 'default',
          msg: this.$t('hsk_practice_sava'),
          cancel: () => {
            //取消阻止本次返回跳转，回归到本页面url
            next(false)
          },
        }
      )
    }
  },
  beforeDestory() {
    window.onbeforeunload = null
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__footer {
  padding: 0;
}
::v-deep .el-dialog__header {
  padding: 0;
}
.dialog-footer {
  display: flex;
  align-items: center;
  border-top: 1px solid #f2f3f5;
  span {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 59px;
    cursor: pointer;
    &:first-child {
      border-right: 1px solid #f2f3f5;
    }
  }
}
</style>
